import React, { Component } from "react"
import PropTypes from "prop-types"
import SbEditable from "storyblok-react"
import OptimizeVariant from "../optimize-variant"

class Optimize extends Component {
  state = {
    tried: 0,
    variant: "0",
    loaded: false,
  }

  async componentDidMount() {
    if (typeof window !== "undefined") {
      this.intervalId = setInterval(() => {
        if (window.google_optimize !== undefined) {
          this.getVariant()
          clearInterval(this.intervalId)
        } else {
          const { tried } = this.state
          if (tried >= 2) {
            clearInterval(this.intervalId)
            this.setState({ loaded: true })
          } else {
            this.setState({ tried: tried + 1 })
          }
        }
      }, 100)
    }
  }

  getVariant = () => {
    const { blok } = this.props
    const { google_optimize } = window

    const variant = google_optimize.get(blok.experiment_id)
    if (variant) {
      this.setState({ variant, loaded: true })
    } else {
      this.setState({ loaded: true })
    }
  }

  render() {
    const { blok } = this.props
    const { variant, loaded } = this.state

    return (
      <SbEditable content={blok}>
        <div
          className="optimize"
          style={{ visibility: loaded ? "visible" : "hidden" }}
        >
          {(variant !== null || blok._editable) &&
            blok.variants.length &&
            blok.variants.map((optimize_variant) => (
              <OptimizeVariant
                key={optimize_variant.id}
                blok={optimize_variant}
                experiment_variant={
                  blok._editable ? optimize_variant.id : variant
                }
              />
            ))}
        </div>
      </SbEditable>
    )
  }
}

Optimize.propTypes = {
  blok: PropTypes.shape({
    experiment_id: PropTypes.string,
    variants: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
}

export default Optimize
